import moment from 'moment'
export default {
    methods: {
        setDateFormat (date, format = 'YYYY-MM-DD', invalidFormatMessage = '') {
            if (date === '' || date === null || date === 'undefined') {
                return invalidFormatMessage
            }

            return moment(date).utc(true).local().format(format)
        },
        setDateFormatEuropeBerlin (date, format = 'YYYY-MM-DD', invalidFormatMessage = '') {
            if (date === '' || date === null || date === 'undefined') {
                return invalidFormatMessage
            }
            // Parse the input date as UTC
            const utcDate = moment.utc(date)

            // Add 2 hours to represent the UTC +2 (APP_TIMEZONE=Europe/Berlin) timezone
            const berlinTime = utcDate.add(2, 'hours')

            return berlinTime.format(format)
        }
    }
}
